import './Pricing.scss';

import React, { useCallback, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import HEADERIMAGE from '../../../../../assets/images/HeadersImages/Pricing-Header.png';
import HeaderLayout from '../../../../../components/HeaderLayout/HeaderLayout';
import LoaderComponent from '../../../../../components/LoaderCompoment/LoaderComponent';
import { setCredits } from '../../../../../redux/actions/credits';
import { showRootPage } from '../../../../../services/navigation-service/navigation.service';
import { getCreditsPublic } from '../../../../../services/prcing-service/pricing.service';

const Pricing = () => {
  const title = 'Pricing';
  const description = 'Credits are only required to message other profiles';
  const image = HEADERIMAGE;
  const pricingCredits = useSelector((state) => state.credits);
  const dispatch = useDispatch();
  const [loader, setLoader] = useState(true);

  const getCurrentPricing = useCallback(async () => {
    try {
      const response = await getCreditsPublic();
      console.log('response', response);
      dispatch(setCredits(response.data.data.bundles));
      setLoader(false);
    } catch (e) {
      console.log(e);
    }
  }, [dispatch]);

  useEffect(() => {
    getCurrentPricing();
  }, [getCurrentPricing]);

  const goToLogin = () => {
    showRootPage();
  };

  return (
    <div className="Pricing">
      <HeaderLayout
        title={title}
        description={description}
        image={image}
        className={'PricingImage'}
      />
      <div className="Pricing-Container ">
        <div className="Pricing-Content">
          <p>
            Access to LocalFlirt is free, howevever, to send messages to other profiles, you must
            first purchase credits. Each credit is used as a message token. The more credits you
            purchase, the better value it is per message. And trust us, you’ll be flirting fast and
            furious, so credit up!
          </p>
          <p className="Credits-Info">
            The credits are sold in several packages, current pricing is below:
          </p>
        </div>
        {!loader ? (
          <div className="Pricing-Table">
            <ul className="PricingBundles-List">
              {pricingCredits.creditBundles.map((credit) => {
                return (
                  <li className="Pricing-Bundle" key={credit.title}>
                    <div className="Pricing-CreditName">
                      <p className="Credit-Messages Para-Data">{credit.messages}</p>
                      <p className="Credits-InfoText Para-Data">CREDITS</p>
                    </div>
                    <div className="Pricing-PricePerMsg">
                      <p className="Saving-Price Para-Data">
                        $ {Math.fround(credit.price / credit.messages).toFixed(2)}
                      </p>
                      <p className="PricePerMessage Para-Data">PRICE PER MESSAGE</p>
                    </div>
                    <button onClick={() => goToLogin()} className="Pricing-Btn">
                      <p className="Credit-Message Para-Data">${credit.price}</p>
                      <p className="BuyNow-Btn Para-Data">BUY NOW</p>
                    </button>
                  </li>
                );
              })}
            </ul>
          </div>
        ) : (
          <LoaderComponent />
        )}
      </div>
    </div>
  );
};

export default Pricing;
